<template>
  <v-container>
    <v-row class="detail-close-wrapper" justify="end">
      <v-col cols="auto">
        <router-link
          :to="{ name: 'Home', hash: '#laureats' }"
          class="detail-close"
        >
          <v-icon :size="35" color="#000">mdi-close</v-icon>
        </router-link>
      </v-col>
    </v-row>
    <v-row class="detail">
      <v-col cols="12" md="auto">
        <div class="detail-nav-wrapper">
          <a href="#" class="detail-nav prev" @click.prevent="toPrev">
            <v-icon :size="35" color="#000">mdi-chevron-left</v-icon>
          </a>
          <a href="#" class="detail-nav next mobile" @click.prevent="toNext">
            <v-icon :size="35" color="#000">mdi-chevron-right</v-icon>
          </a>
        </div>
      </v-col>
      <v-col cols="12" md="auto" class="flex-grow-1">
        <detail-card v-if="graduate" :graduate="graduate"></detail-card>
      </v-col>
      <v-col cols="12" md="auto">
        <div class="detail-nav-wrapper">
          <a href="#" class="detail-nav next desktop" @click.prevent="toNext">
            <v-icon :size="35" color="#000">mdi-chevron-right</v-icon>
          </a>
        </div>
      </v-col>
      <gif-generator :graduate="graduate"></gif-generator>
    </v-row>
    <the-detail-graduates-list
      v-if="graduate"
      :graduate="graduate"
    ></the-detail-graduates-list>
  </v-container>
</template>

<script>
import DetailCard from '@/components/DetailCard'
import TheDetailGraduatesList from '@/components/TheDetailGraduatesList'
import GifGenerator from '@/components/GifGenerator'

export default {
  data() {
    return {
      id: this.$route.params.id
    }
  },
  computed: {
    graduate() {
      return this.$store.getters['graduates/getById'](this.id)
    }
  },
  methods: {
    toPrev() {
      const id = this.$store.getters['graduates/getPrev'](this.id)
      this.$router.push({ name: 'Detail', params: { id } })
    },
    toNext() {
      const id = this.$store.getters['graduates/getNext'](this.id)
      this.$router.push({ name: 'Detail', params: { id } })
    }
  },
  components: {
    DetailCard,
    TheDetailGraduatesList,
    GifGenerator
  }
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.detail-close-wrapper {
  margin-top: 140px;
  position: relative;
  z-index: 1;
}

.detail {
  position: relative;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    margin-top: -70px;
  }
}

.detail-close {
  display: flex;
  width: 45px;
  height: 45px;
  justify-content: center;
  align-items: center;
  border: solid 2px #000;
  background: #00f1b8;
  text-decoration: none;
  transition: background 0.2s;

  &:hover {
    background: #5ae6ff;
  }
}

.detail-nav-wrapper {
  height: 900px;
  display: flex;
  align-items: center;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    height: auto;
  }
}

.detail-nav {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 45px;
  height: 45px;
  border: solid 2px #000;
  text-decoration: none;
  transition: background 0.2s;

  &:hover {
    background: #9200ff;
  }

  &.mobile {
    @media #{map-get($display-breakpoints, 'md-and-up')} {
      display: none;
    }
  }

  &.next.mobile {
    margin-left: 12px;
  }

  &.next.desktop {
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      display: none;
    }
  }
}
</style>
